export const tokens = {
  colors: {
    primary: {
      // Base colors
      black: '#000000',
      white: '#FFFFFF',

      // Neutral, system colors (gray)
      neutral: {
        50: '#F9FAFB',
        100: '#F3F4F6',
        200: '#E5E7EB',
        300: '#D2D5DA',
        400: '#9CA3AF',
        500: '#6D7280',
        550: '#666',
        600: '#4B5563',
        700: '#374151',
        800: '#1F2937',
        900: '#111827',
        1000: '#282828',
        1010: '#1a1a1f',
        1020: '#1D1919',
        1030: '#0c0c0c'
      },

      // Primary, brand colors (blue)
      brand: {
        50: '#EFF6FF',
        100: '#DBEAFE',
        200: '#BFDBFE',
        300: '#93C5FD',
        400: '#60A5FA',
        500: '#3B82F6',
        600: '#2563EB',
        700: '#1D4ED8',
        800: '##1E40AF',
        900: '#1E3A8A'
      }
    },

    secondary: {
      darkBlue: {
        50: '#F8F9FC',
        100: '#EAECF5',
        200: '#C8CCE5',
        300: '#9EA5D1',
        400: '#717BBC',
        500: '#4E5BA6',
        600: '#3E4784',
        700: '#363F72',
        800: '#293056',
        900: '#101323'
      },

      purple: {
        50: '#FAF5FF',
        100: '#F3E8FF',
        200: '#E9D5FF',
        300: '#D8B4FE',
        400: '#C084FC',
        500: '#A855F7',
        600: '#9333EA',
        700: '#7E22CE',
        800: '#6B21A8',
        900: '#581C87'
      },

      orange: {
        50: '#FFF7ED',
        100: '#FFEDD5',
        200: '#FED7AA',
        300: '#FDBA74',
        400: '#FB923C',
        500: '#F97316',
        600: '#EA580C',
        700: '#EA580C',
        800: '#9A3412',
        900: '#7C2D12'
      }
    },

    supporting: {
      // Red / error
      red: {
        50: '#FEF2F2',
        100: '#FEE2E2',
        200: '#FECACA',
        300: '#FCA5A5',
        400: '#FCA5A5',
        500: '#EF4444',
        600: '#DC2626',
        700: '#B91C1C',
        800: '#991B1B',
        900: '#7F1D1D'
      },

      // Yellow / warning
      yellow: {
        50: '#FEFCE8',
        100: '#FEF9C3',
        200: '#FEF08A',
        300: '#FDE047',
        400: '#FACC15',
        500: '#EAB308',
        600: '#CA8A04',
        700: '#A16207',
        800: '#854D0E',
        900: '#713F12'
      },

      // Green / success
      green: {
        50: '#F0FDF4',
        100: '#DCFCE7',
        200: '#BBF7D0',
        300: '#86EFAC',
        400: '#4ADE80',
        500: '#22C55E',
        600: '#16A34A',
        700: '#15803D',
        800: '#166534',
        900: '#14532D'
      }
    },

    brands: {
      blue: {
        50: '#E8EAFF',
        100: '#D1D6FF',
        200: '#A3ABFF',
        300: '#7580FF',
        400: '#667EEA',
        500: '#5A67C7', // (*)
        600: '#333F83',
        700: '#2A3470',
        800: '#22295C',
        900: '#1A1F48',
        1000: '#111434'
      },
      magenta: {
        50: '#fdf2fd',
        100: '#fce7fc',
        200: '#f9cefc',
        300: '#f5a3f0',
        400: '#ee72e1',
        500: '#e338ce',
        600: '#c916a8',
        700: '#a91389',
        800: '#9A218C', // (*)
        900: '#7d1a6f'
      }
    }
  }
};
